import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { Platform, View } from "react-native";
import { LayoutAnimationConfig, FadeInRight, FadeOutDown, LinearTransition } from "react-native-reanimated";
import { Carousel, RenderItemFunction } from "@lookiero/sty-psp-ui";
import { NextBestActionCard } from "../../nextBestActionCard/NextBestActionCard";
import { NextBestActionCards, NextBestActionDefinitionActionWithStatus } from "../NextBestActionCards";
import { style as nextBestActionCarouselStyle } from "./NextBestActionCarousel.style";

const DURATION = 300;

const layoutAnimations = {
  entering: FadeInRight.duration(DURATION),
  exiting: FadeOutDown.duration(DURATION),
  layout: LinearTransition.duration(DURATION),
};

const NextBestActionCarousel: NextBestActionCards = ({ actions = [], basePath, country, segment }) => {
  const [carouselIndex, setCarouselIndex] = useState(0);
  const handleOnActiveIndexChanged = useCallback((activeIndex: number) => setCarouselIndex(activeIndex), []);
  const initialActions = useRef(actions);
  const renderWithLayoutAnimations = Platform.OS !== "web" || initialActions.current !== actions;

  const style = useMemo(() => nextBestActionCarouselStyle(), []);

  const renderCard: RenderItemFunction<NextBestActionDefinitionActionWithStatus> = useCallback(
    ({ item }) => (
      <View key={item.id} style={style.card}>
        <NextBestActionCard action={item} basePath={basePath} country={country} segment={segment} />
      </View>
    ),
    [basePath, country, segment, style.card],
  );

  useEffect(() => {
    if (carouselIndex >= actions.length) {
      setCarouselIndex(actions.length - 1);
    }
  }, [actions.length, carouselIndex]);

  return (
    <LayoutAnimationConfig skipEntering skipExiting>
      <View style={style.carouselContainer} testID="carousel">
        <Carousel
          activeIndex={carouselIndex}
          data={actions}
          layoutAnimations={renderWithLayoutAnimations ? layoutAnimations : undefined}
          style={{ container: style.carouselContainer }}
          onActiveIndexChanged={handleOnActiveIndexChanged}
        >
          {renderCard}
        </Carousel>
      </View>
    </LayoutAnimationConfig>
  );
};

export { NextBestActionCarousel };
